import React from "react"

const Spinner = () => (
  <div className="my-12 w-full flex justify-center">
    <img className="w-12 h-12" src="/images/spinner.svg" />
  </div>
)

export default Spinner
